<template>
  <div class="promotion-hex-icon" :style="wrapperStyle" role="img" :aria-label="alt">
    <svg
      class="promotion-hex-icon__bg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path :d="hexPath" :fill="color" :stroke="color" stroke-width="0.5" stroke-linejoin="round" />
    </svg>

    <img v-if="src" class="promotion-hex-icon__image" :src="src" :alt="alt" />
  </div>
</template>

<script>
const HEX_PATH =
  "M12.96 3.04L19.54 6.71Q20.5 7.25 20.5 8.35L20.5 15.65Q20.5 16.75 19.54 17.29L12.96 20.96Q12 21.5 11.04 20.96L4.46 17.29Q3.5 16.75 3.5 15.65L3.5 8.35Q3.5 7.25 4.46 6.71L11.04 3.04Q12 2.5 12.96 3.04Z";

export default {
  name: "PromotionHexIcon",

  props: {
    src: {
      type: String,
      default: "",
    },

    alt: {
      type: String,
      default: "",
    },

    color: {
      type: String,
      default: "#3b82f6",
    },

    size: {
      type: [Number, String],
      default: 100,
    },
  },

  computed: {
    hexPath() {
      return HEX_PATH;
    },

    wrapperStyle() {
      const dimension = `${this.size}px`;

      return {
        width: dimension,
        height: dimension,
      };
    },
  },
};
</script>

<style scoped lang="postcss">
.promotion-hex-icon {
  @apply relative flex shrink-0 items-center justify-center;
}

.promotion-hex-icon__bg {
  @apply absolute inset-0 h-full w-full;
}

.promotion-hex-icon__image {
  @apply relative z-[1] h-[40%] w-[40%] object-contain;
  filter: brightness(0) invert(1);
}
</style>
